// Moving the whole toy about the play space, in world units with the floor
// at y=0. A finger that pulls further than the skin can stretch takes the toy
// along: it slides across the floor or lifts into the air. Let go, it keeps
// the finger's speed, falls, lands with a bump (the caller squashes the skin
// by that impact), and slides to a stop. Walls are where the view ends: the
// caller reports how far the view pushed the toy back, and it bounces off.
export class ToyCarry{
  constructor({gravity=14,friction=5,bounce=.22}={}){Object.assign(this,{gravity,friction,bounce});this.reset();}
  reset(){this.p=[0,0,0];this.v=[0,0,0];this.held=false;this.start=null;this.last=null;this.moved=false;}
  get busy(){return this.held||this.p[1]>1e-4||Math.hypot(...this.v)>1e-3;}
  get away(){return Math.hypot(...this.p)>1e-4;}
  grab(){this.held=true;this.start=[...this.p];this.v=[0,0,0];this.last=null;}
  // Follow the finger: offset is the world offset beyond the stretch limit,
  // from where the toy was at the grab. It never goes below the floor.
  follow(offset,dt){
    if(!this.held)return;
    const before=[...this.p];
    this.p=[this.start[0]+offset[0],Math.max(0,this.start[1]+offset[1]),this.start[2]+offset[2]];
    if(dt>0){
      // A smoothed hand speed, for the throw on release.
      const k=Math.min(1,dt*18);for(let a=0;a<3;a++)this.v[a]+=((this.p[a]-before[a])/dt-this.v[a])*k;
    }
    if(Math.hypot(...offset)>1e-4)this.moved=true;
  }
  release(limit=9){
    if(!this.held)return;this.held=false;
    const speed=Math.hypot(...this.v);if(speed>limit)this.v=this.v.map(v=>v*limit/speed);
    if(!this.moved)this.v=[0,0,0];
    this.moved=false;
  }
  // Returns the landing speed when it touches down this step, else 0.
  step(dt){
    if(this.held||!(dt>0))return 0;
    let impact=0;
    if(this.p[1]>0||this.v[1]>0){
      this.v[1]-=this.gravity*dt;
      for(let a=0;a<3;a++)this.p[a]+=this.v[a]*dt;
      if(this.p[1]<=0){
        this.p[1]=0;impact=-this.v[1];
        this.v[1]=impact>1.2?impact*this.bounce:0;
      }
    }else for(let a=0;a<3;a++)this.p[a]+=this.v[a]*dt;
    // Sliding on the floor slows it down.
    if(this.p[1]<=1e-4){const k=Math.exp(-this.friction*dt);this.v[0]*=k;this.v[2]*=k;if(Math.hypot(this.v[0],this.v[2])<.01){this.v[0]=0;this.v[2]=0;}}
    return impact;
  }
  // The view pushed the toy back by shift (world): stop there, bouncing a
  // little. Returns the speed it hit the wall with and the way it was going.
  wall(shift){
    // Held, the finger decides: the view only draws it pushed back. Feeding that
    // into the hold would stretch the skin further against the wall, and on.
    if(this.held)return null;
    let hit=null;
    for(let a=0;a<3;a++){
      if(Math.abs(shift[a])<1e-5)continue;
      this.p[a]+=shift[a];if(a===1)this.p[1]=Math.max(0,this.p[1]);
      if(Math.sign(this.v[a])===-Math.sign(shift[a])){
        const speed=Math.abs(this.v[a]);if(!hit||speed>hit.speed)hit={speed,dir:[0,0,0].map((_,i)=>i===a?Math.sign(this.v[a]):0)};
        this.v[a]*=-.2;
      }
    }
    return hit;
  }
}
